export const priorities = [{ value: 'normal', label: 'Normale' }, { value: 'urgent', label: 'Urgente' }];
export function localDate(value) {
    if (!value) return '';
    const date = new Date(value);
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
}
export function isoDate(value) { return value ? new Date(value).toISOString() : null; }
export function taskAction(item) {
    if (!item.active || item.stale) return null;
    if (!item.claimed_by_id) return 'claim';
    return item.can_release ? 'release' : null;
}
export function reminderUntil(hours) { return new Date(Date.now() + hours * 3600000).toISOString(); }
export function reminderDate(choice, custom, now = new Date()) {
    const date = choice === 'custom' ? new Date(custom) : new Date(now);
    if (choice === 'tomorrow') { date.setDate(date.getDate() + 1); date.setHours(9, 0, 0, 0); }
    if (choice === 'hour') date.setTime(date.getTime() + 3600000);
    return Number.isFinite(date.getTime()) ? date.toISOString() : null;
}
export function validReminder(value, now = new Date()) { const delta = new Date(value).getTime() - now.getTime(); return Boolean(value) && delta > 0 && delta <= 7 * 86400000; }
export const taskStates = [
    { value: 'open', label: 'Da fare' }, { value: 'mine', label: 'In carico a me' },
    { value: 'snoozed', label: 'Promemoria rinviati' },
    { value: 'available', label: 'Da assegnare' }, { value: 'closed', label: 'Concluse' }, { value: 'all', label: 'Tutte' },
];
